const style = {
    custom_container:"w-11/12 hidden sm:block",
    heading:"text-[27px] text-center md:text-start font-[500] font-Roboto pb-[20px]",
    section:"w-11/12 mx-auto",
    productTitle:"text-[28px] font-[500] font-Roboto text-[#242424]",
    productDiscountPrice:"font-[500] text-[20px] text-[#077bc4] font-Roboto",
    price:"font-[500] text-[20px] text-[#242424] pl-3  line-through",
    shop_name:"pt-3 text-[15px] text-blue-400 pb-3",
    active_indicator:"absolute bottom-[-27%] left-0 h-[2px] w-full bg-[#007bc4]",
    button:"w-[150px]  h-[50px] my-3 flex items-center justify-center rounded-md cursor-pointer",
    cart_button:"px-[20px] h-[38px] rounded-[20px] bg-[#f63b60] flex items-center justify-center cursor-pointer",
    cart_button_text:"text-[#fff] text-[16px] font-[600]",
    input:"w-full border p-[6px] rounded-[5px] outline-none",
    activeStatus:"w-[10px] h-[10px] rounded-full absolute top-0 right-1 bg-[#40d132]",
    normal_flex:"flex items-center"
};
export default style;